import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroLoans from "./HeaderIntroLoans";
export class TwoWheelerLoan extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroLoans />
        </div>

        <section id="about">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>TWO WHEELER LOANS</h3>
              <p>
                Nothing matches the thrill of owning your brand new bike. We
                understand this, which is why, at ClipTax we offer two wheeler
                loans for you to own the bike of your choice. We offer up to
                100% funding on your new motorcycle or scooter. You can now get
                on the road faster and apply for your motorcycle loan with our
                Two Wheeler Bike Loans.
              </p>
            </header>
          </div>
        </section>

        <section id="why-us">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>HOW IT WORKS?</h3>
              {/* <p>
                Any business offering sale of goods with annual turn over of 40
                lacs or service with annual turn over of 20 lacs would require
                the registration for GST and have a valid GST Number.
              </p> */}
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  <i class="fa fa-diamond"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 1:</h5>
                    <p class="card-text">
                      Quick Register : Fill up a Simple Form
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  <i class="fa fa-language"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 2:</h5>
                    <p class="card-text">
                      Select From Multiple Offers : List of Offers from Multiple
                      Banks Banks
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  <i class="fa fa-object-group"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 3:</h5>
                    <p class="card-text">
                      Apply : Quick Application in less than 15 mins{" "}
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>BENEFITS AND FEATURES OF TWO WHEELER LOANS</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Quick Approval of Loans</a>
                  </h4>
                  <p class="description">
                    For purchasing two-wheelers, one can avail the bank loan
                    quite easily and in a short duration. Once you fill in the
                    eligibility criteria, you can easily avail the loan amount
                    in your bank account with just a few clicks. Quick approval
                    of two-wheeler loans ensures acquiring finance quite easily.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Competitive interest rates</a>
                  </h4>
                  <p class="description">
                    Our interest rates are the best among all lenders; we offer
                    rates and calculations that benefit you the most.
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Reduced burden on the budget</a>
                  </h4>
                  <p class="description">
                    Even if you can pay the whole amount from your pocket for
                    buying a two-wheeler it is rather easy and comfortable to
                    avail the loan and pay the instalments. Moreover it is easy
                    to pay the monthly instalments rather putting a strain on
                    your budget by spending Rs.50,000 to Rs.60,000 all at once.
                    You can also save a bit while enjoying your own vehicle
                    without burdening your budget.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Additional Benefits</a>
                  </h4>
                  <p class="description">
                    You don’t only get a two wheeler insurance loan but due to
                    recent terms you can receive insurance cover or accidental
                    cover along with your loan. Your additional costs will also
                    be covered in your loan during your bike purchase like cost
                    of accessories, registration charges or different seating
                    option for your two-wheeler.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">No compulsion of credit score</a>
                  </h4>
                  <p class="description">
                    Unlike other loans, two-wheeler loan does not require
                    customer’s credit score. You can easily apply and get
                    approved their loan even without having one. Moreover, one
                    can build a credit history after acquiring two-wheeler loan.
                    This will help the borrowers for future credit or loan
                    applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>DOCUMENTS REQUIRED FOR TWO WHEELER LOANS</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">ID Proof</a>
                  </h4>
                  <p class="description">
                    Passport/ Pan Card/ Driver's License/ Voter's ID along with recent passport size photographs
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Address Proof</a>
                  </h4>
                  <p class="description">
                    Passport/ Driver's License/ Voter's ID/ Utility Bill
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Income Proof if required</a>
                  </h4>
                  <p class="description">
                    Last 3 month's salary slips/Form 16/Last 3 month's  bank statement reflecting salary credits/ 3 year's ITR
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Bank Statement</a>
                  </h4>
                  <p class="description">
                    Last 6 month's statement is mandatory
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Residence Ownership Proof</a>
                  </h4>
                  <p class="description">
                    Mandatory and should be in the name of Applicant/ Applicant's Parents/ Spouse
                  </p>
                </div>
              </div>

              
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default TwoWheelerLoan;
